<template>
  <div class="page-header" :class="{ line: line }">
    <slot name="title"><h1 class="title" v-text="title"></h1></slot>
    <div class="actions">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    line: {
      type: Boolean,
      default: true,
    },
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  position: relative;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &.line::before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    content: " ";
    width: 5px;
    height: 20px;
    background-color: $theme-color;
  }
  .title {
    color: #000;
    font-size: 16px;
    white-space: nowrap;
  }
  .actions {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-input + .el-button {
      margin-left: 10px;
    }
  }
}
</style>
